module.exports = __webpack_public_path__ + "static/media/bicc_center_outside_right.e9137bc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/bicc_center_outside_right.jpg
// module id = 1114
// module chunks = 0